
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.52 5.417h6.25c.864 0 1.563.7 1.563 1.562v7.292c0 .863-.7 1.562-1.562 1.562H3.229c-.863 0-1.562-.7-1.562-1.562V4.896c0-.863.7-1.563 1.562-1.563h5.209l2.083 2.084zm4.063 3.75a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0zm-.717 2.083h.217c.967 0 1.75.784 1.75 1.75v.542c0 .345-.28.625-.625.625h-4.583a.625.625 0 01-.625-.625V13c0-.966.784-1.75 1.75-1.75h.217a2.274 2.274 0 001.899 0z","fill":"#348EF6"}})])
          )
        }
      }
    